<template>
    <div>
        <div class="p-grid">
            <div class="p-col-12">
                <div class="card">
                    <div class="row col-12 col-4 font-12">
                        <h4>Налаштування Email</h4>
                        <p>Додайте основну та додаткову пошту</p>

                        <div class="form-row">
                            <div class="form-group col-md-4">
                                <label for="inputEmail4"><b>Основна пошта (ОСК) *</b></label>
                                <input type="email" class="form-control" v-model="emails.osk" placeholder="Email">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-4">
                                <label for="inputEmail4"><b>Додаткова пошта (адмін КРМ)</b></label>
                                <input type="email" class="form-control" v-model="emails.krm" placeholder="Email">
                            </div>
                            <div class="form-group col-md-4">
                                <label for="inputEmail4"><b>Додаткова пошта (адмін АВР)</b></label>
                                <input type="email" class="form-control" v-model="emails.avr" placeholder="Email">
                            </div>
                            <div class="form-group col-md-4">
                                <label for="inputEmail4"><b>Додаткова пошта (адмін я5000)</b></label>
                                <input type="email" class="form-control" v-model="emails.ya5000" placeholder="Email">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-4">
                                <label for="inputEmail4"><b>Додаткова пошта (адмін ЩО125)</b></label>
                                <input type="email" class="form-control" v-model="emails.sho125" placeholder="Email">
                            </div>
                            <div class="form-group col-md-4">
                                <label for="inputEmail4"><b>Додаткова пошта (адмін Клемні ряди)</b></label>
                                <input type="email" class="form-control" v-model="emails.klemni" placeholder="Email">
                            </div>
                            <div class="form-group col-md-4">
                                <label for="inputEmail4"><b>Додаткова пошта (адмін Плавні пуски)</b></label>
                                <input type="email" class="form-control" v-model="emails.plavni" placeholder="Email">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-4">
                                <label for="inputEmail4"><b>Додаткова пошта (адмін ЩО90)</b></label>
                                <input type="email" class="form-control" v-model="emails.sho90" placeholder="Email">
                            </div>
                            <div class="form-group col-md-4">
                                <label for="inputEmail4"><b>Додаткова пошта (адмін Прайс-лист)</b></label>
                                <input type="email" class="form-control" v-model="emails.price" placeholder="Email">
                            </div>
                            <div class="form-group col-md-4">
                                <label for="inputEmail4"><b>Додаткова пошта (адмін Сервіс по шинам)</b></label>
                                <input type="email" class="form-control" v-model="emails.kalkulyator_shini" placeholder="Email">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-4">
                                <button
                                    type="submit"
                                    class="btn btn-primary"
                                    @click.prevent="save"
                                >
                                    Зберегти
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AppLayout from "../Layouts/AppLayout";
import Button from "primevue/button";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import FormHelper from './mixins/form_helper';

export default {
    props: {
        data: {
            type: Array,
            default: [],
            required: false,
        }
    },

    name: "Index",
    layout: AppLayout,
    components: {
        AppLayout,
        Button,
    },
    mixins: [FormHelper],
    data() {
        return {
            emails: {
                osk: null,
                krm: null,
                avr: null,
                ya5000: null,
                sho125: null,
                sho90: null,
                klemni: null,
                plavni: null,
                price: null,
                kalkulyator_shini: null,
            },
        }
    },
    mounted() {
        if (Object.keys(this.data).length) {
            this.emails.osk = this.data.osk;
            this.emails.krm = this.data.krm;
            this.emails.avr = this.data.avr;
            this.emails.ya5000 = this.data.ya5000;
            this.emails.sho125 = this.data.sho125;
            this.emails.sho90 = this.data.sho90;
            this.emails.klemni = this.data.klemni;
            this.emails.plavni = this.data.plavni;
            this.emails.price = this.data.price;
            this.emails.kalkulyator_shini = this.data.kalkulyator_shini;
        }
    },
    methods: {
        save() {
            axios.post(this.route('api.offer.email'), {emails: this.emails})
                .then((result) => {
                    window.scroll(0, 0);
                    alert("Данные успешно внесены!");
                    // location.reload();
                }).catch((error) => {
                    alert('Error!');
                    
                    console.log(error);
                    window.scroll(0, 0);
                })
        }
    }
}
</script>

<style scoped>
.form-row {
    display: flex;
    width: 100%;
    gap: 20px;
    padding-top: 20px;
}
</style>